/* ============================================================================
   ADMIN → FORMULAS → tab PROMPT (PROTOTAIP DESIGN · 27 Okt 2026)
   ============================================================================
   Pariti dengan popup Module Settings sedia ada (bahagian "Master Prompt — 3 Mode", "Wajib Append",
   Scene 2 + prepend, "Sub-Module (Variasi)"):
   • Formula Classic → editor 3 mode (Mode 1/2/3) seperti sekarang + butang "Convert to blocks".
   • Formula Blocks  → senarai block (ON/OFF, Shared/Custom) + prompt penuh ke OpenAI. 3 mode lama kini
     = block "Avatar & gender" yang ada 3 versi.
   • Kedua-dua: "Added after AI" (Wajib Append imej + video; Scene 2 + prepend untuk formula 2 scene)
     dan "Variations" (sub-module: nama + prompt sendiri).
   ⛔ RUPA SAHAJA — keadaan tempatan, tiada peti besi, tiada master prompt sebenar.
   ========================================================================== */
import { useState } from 'react';
import { Lock, Plus, X, ChevronDown, ChevronUp } from 'lucide-react';
import { Segmented, Btn } from '../design/ui';
import { Suis, Kotak, Medan, BarisSuis } from './FormulaAdminUi';
import {
    FORMULA_CONTOH, MOD_PROMPT, PEMEGANG_TEMPAT, APPEND_CONTOH, SUB_MODUL_CONTOH, blockUntukFormat, teksBlock,
} from '../utils/formulaAdminContoh';

const contohClassic = (nama, mod) => `[Sample text — the real ${nama} master prompt for "${mod}" is kept in the vault and is not shown in this prototype.]\n\nYou are a TikTok Shop video scriptwriter for Malaysian buyers…`;

export default function FormulaAdminPrompt({ f, onUbah, onNota }) {
    /* ── Block ── */
    const [tetapan, setTetapan] = useState(() => ({}));
    const blocks = blockUntukFormat(f.format);
    const [pilihId, setPilihId] = useState(blocks[0]?.id);
    const [modPratonton, setModPratonton] = useState('mode1');
    const blockPilih = blocks.find((b) => b.id === pilihId) || blocks[0];
    const tet = (id) => ({ on: true, mod: 'shared', ...(f.tetapanAwal?.[id] || {}), ...(tetapan[id] || {}) });
    const ubahTet = (id, v) => { setTetapan((t) => ({ ...t, [id]: { ...tet(id), ...v } })); onNota(''); };
    const pakaiShared = (b) => FORMULA_CONTOH.filter((x) => x.mod === 'blocks' && b.untuk.includes(x.format)).length;

    /* ── Classic 3 mode ── */
    const [modClassic, setModClassic] = useState('mode1');
    const [teksClassic, setTeksClassic] = useState(() => Object.fromEntries(MOD_PROMPT.map((m) => [m.id, contohClassic(f.nama, m.label)])));

    /* ── Wajib Append + variasi ── */
    const [append, setAppend] = useState(() => ({ ...APPEND_CONTOH, prependOn: !!f.duaScene }));
    const ubahAppend = (k, v) => { setAppend((a) => ({ ...a, [k]: v })); onNota(''); };
    const [sub, setSub] = useState(() => ({ on: !!f.subModul, label: 'Teknik', senarai: f.subModul ? SUB_MODUL_CONTOH : [], buka: '' }));
    const ubahSub = (v) => { setSub((s) => ({ ...s, ...v })); onNota(''); };

    const pratonton = blocks
        .filter((b) => b.kunci || tet(b.id).on)
        .map((b) => {
            const isi = b.id === 'customer'
                ? `${teksBlock(b, f, tet(b.id))}\nCustomer note: "…typed by the customer in the prompt box…"`
                : teksBlock(b, f, tet(b.id), modPratonton);
            return `### ${b.nama.toUpperCase()}\n${isi}`;
        })
        .join('\n\n');

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {f.mod === 'classic' && (
                <Kotak tajuk="Master prompt — 3 modes" kanan={<Btn variant="ghost" size="sm" onClick={() => { onUbah('mod', 'blocks'); onNota('Prototype: showing how it would look as blocks.'); }}>Convert to blocks</Btn>}>
                    <p className="fma-nota" style={{ margin: '0 0 10px' }}>Loaded from the vault · saved 6 Oct 2026 by masterzuheir@gmail.com</p>
                    <Segmented value={modClassic} onChange={setModClassic}
                        options={MOD_PROMPT.map((m) => ({ value: m.id, label: `${m.label} · ${teksClassic[m.id].length.toLocaleString('en-US')}` }))} />
                    <textarea className="fma-teks" style={{ marginTop: 10, minHeight: 180 }} value={teksClassic[modClassic]}
                        onChange={(e) => { setTeksClassic((t) => ({ ...t, [modClassic]: e.target.value })); onNota(''); }} />
                    <p className="fma-nota" style={{ margin: '8px 0 0' }}>Product data (name, link, gender, avatar) is added at the end by the system. An empty Mode 2 or 3 uses Mode 1.</p>
                </Kotak>
            )}

            {f.mod === 'blocks' && (
                <div className="fma-dua">
                    <Kotak tajuk="Blocks" kanan={<span className="fma-nota">top → bottom = prompt order</span>}>
                        <div className="fma-blocks">
                            {blocks.map((b) => {
                                const t = tet(b.id);
                                const off = !b.kunci && !t.on;
                                return (
                                    <button key={b.id} type="button" onClick={() => setPilihId(b.id)}
                                        className={'fma-block' + (b.id === blockPilih?.id ? ' is-pilih' : '') + (off ? ' is-off' : '')}>
                                        {b.kunci
                                            ? <span className="fma-kunci" title="Owned by SESAAT"><Lock size={14} /></span>
                                            : <Suis on={t.on} label={`${b.nama} on/off`} onTukar={(v) => ubahTet(b.id, { on: v })} />}
                                        <span style={{ minWidth: 0 }}>
                                            <span className="fma-block__nama">{b.nama}</span>
                                            <span className="fma-block__nota">{b.nota}</span>
                                        </span>
                                        {b.kunci
                                            ? <span className="fma-tanda">Locked</span>
                                            : off
                                                ? <span className="fma-tanda fma-tanda--off">OFF</span>
                                                : <span className={'fma-tanda' + (t.mod === 'custom' ? ' fma-tanda--custom' : '')}>{t.mod === 'custom' ? 'Custom' : 'Shared'}</span>}
                                    </button>
                                );
                            })}
                        </div>
                    </Kotak>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, minWidth: 0 }}>
                        {blockPilih && (() => {
                            const b = blockPilih;
                            const t = tet(b.id);
                            const bolehEdit = !b.kunci && t.mod === 'custom';
                            const ubahTeks = (v) => (b.tigaMod
                                ? ubahTet(b.id, { teksMod: { ...(t.teksMod || b.teksIkutMod), [modPratonton]: v } })
                                : ubahTet(b.id, { teks: v }));
                            return (
                                <Kotak tajuk={b.nama} kanan={!b.kunci && (
                                    <Segmented value={t.mod}
                                        onChange={(v) => ubahTet(b.id, v === 'custom' && t.mod !== 'custom'
                                            ? { mod: 'custom', teks: t.teks ?? teksBlock(b, f, { mod: 'shared' }), teksMod: t.teksMod ?? { ...b.teksIkutMod } }
                                            : { mod: v })}
                                        options={[{ value: 'shared', label: 'Shared' }, { value: 'custom', label: 'Custom' }]} />
                                )}>
                                    {b.tigaMod && (
                                        <div style={{ marginBottom: 10 }}>
                                            <Segmented value={modPratonton} onChange={setModPratonton} options={MOD_PROMPT.map((m) => ({ value: m.id, label: m.label }))} />
                                        </div>
                                    )}
                                    <textarea className="fma-teks" readOnly={!bolehEdit}
                                        value={teksBlock(b, f, t, modPratonton)} onChange={(e) => ubahTeks(e.target.value)} />
                                    <p className="fma-nota" style={{ margin: '8px 0 0' }}>
                                        {b.kunci
                                            ? 'Owned by SESAAT — always ON so the card and robot understand the result.'
                                            : !t.on
                                                ? 'OFF — this block is not sent to OpenAI for this formula.'
                                                : t.mod === 'custom'
                                                    ? 'Custom — this text is only for this formula.'
                                                    : `Shared — same text in ${pakaiShared(b)} formulas. Editing it in the blocks library changes all of them.`}
                                        {b.tigaMod && ' The version used depends on whether the customer picked an avatar and gender (same as the old Mode 1/2/3).'}
                                    </p>
                                </Kotak>
                            );
                        })()}
                        <Kotak tajuk="Full prompt sent to OpenAI" kanan={<span className="fma-nota">~{Math.round(pratonton.length / 4).toLocaleString('en-US')} tokens · {MOD_PROMPT.find((m) => m.id === modPratonton)?.label}</span>}>
                            <pre className="fma-pratonton">{pratonton}</pre>
                        </Kotak>
                    </div>
                </div>
            )}

            <Kotak tajuk="Added after AI — not sent to OpenAI" kanan={<span className="fma-nota">zero cost · pasted into Flow with the prompt</span>}>
                <div className="fma-borang" style={{ maxWidth: 'none' }}>
                    {f.format !== 'text' && (
                        <Medan id="fma-app-img" label="Image prompt — always add">
                            <textarea id="fma-app-img" className="fma-teks" style={{ minHeight: 80 }} value={append.imej} onChange={(e) => ubahAppend('imej', e.target.value)} />
                        </Medan>
                    )}
                    {f.format === 'video' && (
                        <Medan id="fma-app-vid" label={f.duaScene ? 'Video prompt — always add (Scene 1)' : 'Video prompt — always add'}>
                            <textarea id="fma-app-vid" className="fma-teks" style={{ minHeight: 80 }} value={append.video} onChange={(e) => ubahAppend('video', e.target.value)} />
                        </Medan>
                    )}
                    {f.format === 'video' && f.duaScene && (
                        <>
                            <Medan id="fma-app-vid2" label="Video prompt — always add (Scene 2)">
                                <textarea id="fma-app-vid2" className="fma-teks" style={{ minHeight: 70 }} value={append.video2} onChange={(e) => ubahAppend('video2', e.target.value)} />
                            </Medan>
                            <div className="fma-kotak" style={{ padding: '4px 14px' }}>
                                <BarisSuis nama="Put a line ABOVE Scene 2 (prepend)" on={append.prependOn} onTukar={(v) => ubahAppend('prependOn', v)} />
                            </div>
                            {append.prependOn && (
                                <textarea aria-label="Scene 2 prepend text" className="fma-teks" style={{ minHeight: 60 }} value={append.prepend2} onChange={(e) => ubahAppend('prepend2', e.target.value)} />
                            )}
                        </>
                    )}
                    <p className="fma-nota" style={{ margin: 0 }}>
                        {f.format === 'text' ? 'Text formulas have nothing to paste into Flow, so no append is needed. ' : ''}
                        Placeholders: {PEMEGANG_TEMPAT.join(' · ')}
                    </p>
                </div>
            </Kotak>

            <Kotak tajuk="Variations (sub-modules)" kanan={<Suis on={sub.on} label="Enable variations" onTukar={(v) => ubahSub({ on: v })} />}>
                {!sub.on && <p className="fma-nota" style={{ margin: 0 }}>Off — customers get one version of this formula. Turn on to offer variations, each with its own prompt.</p>}
                {sub.on && (
                    <div className="fma-borang" style={{ maxWidth: 'none' }}>
                        <Medan id="fma-sub-label" label="Choice label (what customers see)">
                            <input id="fma-sub-label" className="s-input" value={sub.label} onChange={(e) => ubahSub({ label: e.target.value })} style={{ maxWidth: 260 }} />
                        </Medan>
                        <div>
                            {sub.senarai.map((s, i) => (
                                <div key={s.id} style={{ borderTop: i ? '1px solid var(--s-line)' : 0, padding: '8px 0' }}>
                                    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                        <input className="s-input" aria-label="Variation name" value={s.nama} placeholder="Variation name"
                                            onChange={(e) => ubahSub({ senarai: sub.senarai.map((x) => (x.id === s.id ? { ...x, nama: e.target.value } : x)) })} style={{ flex: 1 }} />
                                        <Btn variant="quiet" size="sm" icon={sub.buka === s.id ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                                            onClick={() => ubahSub({ buka: sub.buka === s.id ? '' : s.id })}>Prompt</Btn>
                                        <Btn variant="quiet" size="sm" icon={<X size={14} />} aria-label={`Remove ${s.nama}`}
                                            onClick={() => ubahSub({ senarai: sub.senarai.filter((x) => x.id !== s.id) })} />
                                    </div>
                                    {sub.buka === s.id && (
                                        <textarea className="fma-teks" style={{ marginTop: 8, minHeight: 90 }} value={s.prompt}
                                            onChange={(e) => ubahSub({ senarai: sub.senarai.map((x) => (x.id === s.id ? { ...x, prompt: e.target.value } : x)) })} />
                                    )}
                                </div>
                            ))}
                        </div>
                        <div>
                            <Btn variant="ghost" size="sm" icon={<Plus size={14} />}
                                onClick={() => ubahSub({ senarai: [...sub.senarai, { id: `sm_${Math.random().toString(36).slice(2, 8)}`, nama: '', prompt: '' }] })}>
                                Add variation
                            </Btn>
                        </div>
                        <p className="fma-nota" style={{ margin: 0 }}>A variation's prompt replaces this formula's prompt when the customer picks it.</p>
                    </div>
                )}
            </Kotak>

            <p className="fma-nota" style={{ margin: 0, padding: '10px 12px', borderRadius: 'var(--s-r)', background: 'var(--s-ok-soft)', color: 'var(--s-ok)' }}>
                Prompt changes affect every customer who uses this formula.
            </p>
        </div>
    );
}
